import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import useNotifications from "../../features/Notification/useNotifications";
import NotificationItem from "./NotificationItem";
import InfiniteScroll from "../common/InfiniteScroll/InfiniteScroll";
import { useTranslation } from "react-i18next";

const NOTIF_SCROLL_ID = "notification-scroll-area";

const NotificationBell: React.FC = () => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const { notifications, loading, hasMore, loadMore, markRead, unreadCount } = useNotifications();

	return (
		<div className="relative">
			<button
				type="button"
				onClick={() => setOpen(true)}
				className="relative flex items-center justify-center"
				data-testid="notification-bell"
				aria-label={t("psdaCommon.notifications.title")}>
				<NotificationsOutlinedIcon sx={{ fontSize: 26, color: "#161616" }} />
				{unreadCount > 0 && (
					<span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full px-1.5 py-0.5">
						{unreadCount}
					</span>
				)}
			</button>
			<Drawer
				anchor="right"
				open={open}
				onClose={() => setOpen(false)}
				PaperProps={{
					className: "max-w-md w-full bg-white shadow-2xl",
					sx: { borderTopLeftRadius: 12, borderBottomLeftRadius: 12 },
				}}>
				{/* Header */}
				<div className="flex items-center justify-between p-6 border-b h-[50px]">
					<IconButton onClick={() => setOpen(false)} className="!mr-2">
						<ArrowBackIosNewIcon className="text-gray-500" />
					</IconButton>
					<h2 className="text-2xl font-bold text-gray-900 flex-1 text-center">{t("psdaCommon.notifications.title")}</h2>
					<span className="w-8" /> {/* Spacer for symmetry */}
				</div>
				{/* Notification List with Infinite Scroll */}
				<InfiniteScroll
					items={notifications || []}
					renderItem={item => <NotificationItem notification={item} markRead={markRead} setOpen={setOpen} />}
					isLoading={loading}
					isFetching={loading}
					hasNextPage={hasMore}
					fetchNextPage={loadMore}
					noDataMessage={t("psdaCommon.notifications.noNotifications")}
					className="p-4 space-y-3 max-h-[calc(100vh-70px)] overflow-y-auto"
					scrollRootId={NOTIF_SCROLL_ID}
				/>
			</Drawer>
		</div>
	);
};

export default NotificationBell;
